import { render, staticRenderFns } from "./app-shop-price-view.vue?vue&type=template&id=13b98999&"
import script from "./app-shop-price-view.vue?vue&type=script&lang=js&"
export * from "./app-shop-price-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports